import type { AbilityId } from "@pit/protocol";
import rawConfig from "../presentation/projectileVisuals.json";
import { ABILITY_META_BY_ID } from "./abilityCatalog.js";
import {
  loadProjectileVisualConfig,
  type ProjectileImpactProfile,
  type ProjectileVisualProfile,
} from "./projectileVisualConfig.js";

export type {
  ProjectileImpactProfile,
  ProjectilePresentationProfile,
  ProjectileVisualProfile,
} from "./projectileVisualConfig.js";

/** Presentation-only JSON is validated and converted once at module load. */
export const PROJECTILE_PRESENTATION_CATALOG = loadProjectileVisualConfig(
  rawConfig,
  new Set(ABILITY_META_BY_ID.keys()),
);

export const DEFAULT_PROJECTILE_VISUAL = PROJECTILE_PRESENTATION_CATALOG.defaultProfile.flight;
export const DEFAULT_PROJECTILE_IMPACT = PROJECTILE_PRESENTATION_CATALOG.defaultProfile.impact;

/** Autos, unknown IDs and unconfigured spells share the configured fallback. */
export function projectileVisualFor(abilityId: AbilityId | null): ProjectileVisualProfile {
  return PROJECTILE_PRESENTATION_CATALOG.resolve(abilityId).flight;
}

export function projectileImpactVisualFor(abilityId: AbilityId | null): ProjectileImpactProfile {
  return PROJECTILE_PRESENTATION_CATALOG.resolve(abilityId).impact;
}
